import { render, staticRenderFns } from "./customerimage.vue?vue&type=template&id=446e6d18&"
import script from "./customerimage.vue?vue&type=script&lang=js&"
export * from "./customerimage.vue?vue&type=script&lang=js&"
import style0 from "./customerimage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports